import _ from 'lodash';
import { useContext, useEffect } from 'react';
import { Col, Row } from 'reactstrap';
import { shouldShowField, validateField } from '../../../../../components/InputField/helper';
import { WrapperField } from '../../../../../components/InputField/WrapperField';
import { DialogContext } from '../../../../../store/context/DialogContext';
import { useTranslation } from '../../../../../store/context/TranslationContext';
import ButtonGroupNew from '../../BusinessLiteForms/components/ButtonGroupNew';
import { InputLabel } from '../../components/IndividualLite/UserDetailsForm';
import { getNextStep, getVisibleWizardFieldOrder, WIZARD_NUM } from '../helper';

const ComplianceDetails = ({
    asLabel,
    hideButtons,
    data,
    handleUpdate,
    hasError,
    setHasError,
    loading,
    cyclosFields,
    errors,
    setErrors,
    iPlusFields,
    wizard,
    applicationForm,
    isForEDD,
    handleChange,
    handlePrev,
    editMode
}) => {
    const { showError } = useContext(DialogContext);
    const { t } = useTranslation();

    const checkNext = () => {
        const visibleFieldOrder = getVisibleWizardFieldOrder({
            fields: iPlusFields,
            wizard,
            data,
        });

        for (const fieldPath of visibleFieldOrder) {
            const fieldError = _.get(errors, fieldPath);
            if (fieldError) {
                setHasError(true);
                showError(fieldError);
                return false;
            }
        }
        setErrors({});
        return true;
    };

    const handleSubmit = () => {
        const isFormFieldValid = checkNext();
        if (isFormFieldValid) {
            setHasError(false);
            return handleUpdate({ nextStep: getNextStep(wizard, applicationForm, data, editMode) });
        }
    };

    const handleUpdateFormData = (updatedData) => {
        handleChange(updatedData);
    };

    const handleErrors = (field, errorMsg) => {
        setErrors((prevErrors) => {
            const updatedErrors = _.cloneDeep(prevErrors);
            _.set(updatedErrors, field, errorMsg);
            return updatedErrors;
        })
    }

    return (
        <div className="row">
            <div className="col-12 ">
                <h2 style={{ fontWeight: 'bolder' }} className='pt-3 mb-4'>Compliance</h2>

                <InputLabel label="Name of Compliance Officer or equivalent" required labelStyle={{ fontSize: 15 }} />

                <Row>
                    <Col className="col-xl-6 col-12">
                        <WrapperField
                            disabled={asLabel}
                            jsonField={cyclosFields["complianceOfficerFirstName"]}
                            dataObj={data}
                            onChange={handleUpdateFormData}
                            showError={hasError}
                            onError={(errorMsg) => handleErrors('complianceOfficerFirstName', errorMsg)}
                            isForEDD={isForEDD}
                        />
                    </Col>
                    <Col className="col-xl-6 col-12">
                        <WrapperField
                            disabled={asLabel}
                            jsonField={cyclosFields["complianceOfficerLastName"]}
                            dataObj={data}
                            onChange={handleUpdateFormData}
                            showError={hasError}
                            onError={(errorMsg) => handleErrors('complianceOfficerLastName', errorMsg)}
                            isForEDD={isForEDD}
                        />
                    </Col>
                </Row>

                <Row>
                    <Col className="col-xl-6 col-12">
                        <WrapperField
                            disabled={asLabel}
                            jsonField={cyclosFields["complianceOfficerEmail"]}
                            dataObj={data}
                            onChange={handleUpdateFormData}
                            showError={hasError}
                            onError={(errorMsg) => handleErrors('complianceOfficerEmail', errorMsg)}
                            isForEDD={isForEDD}
                        />
                    </Col>
                    <Col className="col-xl-6 col-12">
                        <WrapperField
                            disabled={asLabel}
                            jsonField={cyclosFields["complianceOfficerPhone"]}
                            dataObj={data}
                            onChange={handleUpdateFormData}
                            showError={hasError}
                            onError={(errorMsg) => handleErrors('complianceOfficerPhone', errorMsg)}
                            isForEDD={isForEDD}
                        />
                    </Col>
                </Row>

                <div className='py-1'>
                    <WrapperField
                        disabled={asLabel}
                        jsonField={cyclosFields["hasAmlProgram"]}
                        dataObj={data}
                        onChange={handleUpdateFormData}
                        showError={hasError}
                        onError={(errorMsg) => handleErrors('hasAmlProgram', errorMsg)}
                        isForEDD={isForEDD}
                    />
                </div>
                <div className='py-1'>
                    <WrapperField
                        disabled={asLabel}
                        jsonField={cyclosFields["amlCftReviewed"]}
                        dataObj={data}
                        onChange={handleUpdateFormData}
                        showError={hasError}
                        onError={(errorMsg) => handleErrors('amlCftReviewed', errorMsg)}
                        isForEDD={isForEDD}
                    />
                </div>
                <div className='py-1'>
                    <WrapperField
                        disabled={asLabel}
                        jsonField={cyclosFields["upcomingAmlReview"]}
                        dataObj={data}
                        onChange={handleUpdateFormData}
                        showError={hasError}
                        onError={(errorMsg) => handleErrors('upcomingAmlReview', errorMsg)}
                        isForEDD={isForEDD}
                    />
                </div>
                <div className='py-1'>
                    <WrapperField
                        disabled={asLabel}
                        jsonField={cyclosFields["hasAmlPolicy"]}
                        dataObj={data}
                        onChange={handleUpdateFormData}
                        showError={hasError}
                        onError={(errorMsg) => handleErrors('hasAmlPolicy', errorMsg)}
                        isForEDD={isForEDD}
                    />
                </div>
                <div className='py-1'>
                    <WrapperField
                        disabled={asLabel}
                        jsonField={cyclosFields["numberOfComplianceStaff"]}
                        dataObj={data}
                        onChange={handleUpdateFormData}
                        showError={hasError}
                        onError={(errorMsg) => handleErrors('numberOfComplianceStaff', errorMsg)}
                        isForEDD={isForEDD}
                    />
                </div>
                <div className='py-1'>
                    <WrapperField
                        disabled={asLabel}
                        jsonField={cyclosFields["monitoringTools"]}
                        dataObj={data}
                        onChange={handleUpdateFormData}
                        showError={hasError}
                        onError={(errorMsg) => handleErrors('monitoringTools', errorMsg)}
                        isForEDD={isForEDD}
                    />
                </div>
                <WrapperField
                    disabled={asLabel}
                    jsonField={cyclosFields["hasComplaintsPolicy"]}
                    dataObj={data}
                    onChange={handleUpdateFormData}
                    showError={hasError}
                    onError={(errorMsg) => handleErrors('hasComplaintsPolicy', errorMsg)}
                    isForEDD={isForEDD}
                />

                <WrapperField
                    disabled={asLabel}
                    jsonField={cyclosFields["hasCustomerAgreement"]}
                    dataObj={data}
                    onChange={handleUpdateFormData}
                    showError={hasError}
                    onError={(errorMsg) => handleErrors('hasCustomerAgreement', errorMsg)}
                    isForEDD={isForEDD}
                />

                <WrapperField
                    disabled={asLabel}
                    jsonField={cyclosFields["noCustomerAgreementExplanation"]}
                    dataObj={data}
                    onChange={handleUpdateFormData}
                    showError={hasError}
                    onError={(errorMsg) => handleErrors('noCustomerAgreementExplanation', errorMsg)}
                    isForEDD={isForEDD}
                />

                <WrapperField
                    disabled={asLabel}
                    jsonField={cyclosFields["hasSanctionsProgram"]}
                    dataObj={data}
                    onChange={handleUpdateFormData}
                    showError={hasError}
                    onError={(errorMsg) => handleErrors('hasSanctionsProgram', errorMsg)}
                    isForEDD={isForEDD}
                />

                <div className='mt-4'>
                    <ButtonGroupNew
                        onNextClick={handleSubmit}
                        onBackClick={() => { handlePrev() }}
                        step={WIZARD_NUM.ComplianceDetails}
                        hideSubmitButton={hideButtons}
                        showPageNum={false}
                        pageNum={WIZARD_NUM.ComplianceDetails}
                        asLabel={false}
                        loading={loading}
                    />
                </div>
            </div>
        </div>
    );
};

export default ComplianceDetails;
